/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: e86a911c (Thu May 21 20:23:17 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface Address
 */
export interface Address {
  /**
   * The name of the location where students will meet in person e.g. the name of a church.
   * @type string
   * @memberof Address
   */
  locationName: string
  /**
   *
   * @type string
   * @memberof Address
   */
  streetAddress1: string
  /**
   *
   * @type string
   * @memberof Address
   */
  streetAddress2?: string
  /**
   *
   * @type string
   * @memberof Address
   */
  city: string
  /**
   *
   * @type string
   * @memberof Address
   */
  state?: string
  /**
   *
   * @type string
   * @memberof Address
   */
  zip?: string
  /**
   * Alpha-2 two-letter ISO Country Code
   * @type string
   * @memberof Address
   */
  countryCode: string
}

export function AddressFromJSON(json: any): Address {
  return AddressFromJSONTyped(json, false)
}

export function AddressFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Address {
  if (json === undefined || json === null) {
    return json
  }
  return {
    locationName: json['locationName'],
    streetAddress1: json['streetAddress1'],
    streetAddress2: !exists(json, 'streetAddress2')
      ? undefined
      : json['streetAddress2'],
    city: json['city'],
    state: !exists(json, 'state') ? undefined : json['state'],
    zip: !exists(json, 'zip') ? undefined : json['zip'],
    countryCode: json['countryCode'],
  }
}

export function AddressToJSON(value?: Address | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    locationName: value.locationName,
    streetAddress1: value.streetAddress1,
    streetAddress2: value.streetAddress2,
    city: value.city,
    state: value.state,
    zip: value.zip,
    countryCode: value.countryCode,
  }
}
